module.exports = __webpack_public_path__ + "static/img/1_2.d6094650.jpg";